import { render, staticRenderFns } from "./ElectronicBillPayment.vue?vue&type=template&id=734ba295&scoped=true&"
import script from "./ElectronicBillPayment.vue?vue&type=script&lang=js&"
export * from "./ElectronicBillPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734ba295",
  null
  
)

export default component.exports